import { GET_CATEGORIES, SELECT_CATEGORY } from 'modules/dashboard/store/constants';

export const getCategories = () => ({
  type: GET_CATEGORIES,
});

export const selectCategory = (categoryId) => ({
  type: SELECT_CATEGORY,
  payload: {
    categoryId,
  },
});
